import { Tooltip } from "@mui/material"
import React from "react"

import { formatNumber, formatNumberAuto } from "@/utils/format"

export function UsdAmountBlock(props: { amount?: number | string }) {
  const { amount } = props

  if (amount === undefined) return null

  const longValue = formatNumber(amount, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 18,
  })

  return (
    <Tooltip title={<span>{longValue} USD</span>}>
      <span>${formatNumberAuto(amount, 2)}</span>
    </Tooltip>
  )
}
